import Modal from 'react-bootstrap/Modal';

import { formatCurrency, getTotalItems } from '../../utils/numbers';
import { formatDateAndTime } from '../../utils/dates';
import { ModalButton } from '../../styles/StyledComponents';

const IssueMovementConfirmationModal = ({
    actionHandler,
    closeHandler,
    requestor,
    vehicle,
    date,
    odometer,
    description,
    issueType,
    details,
    show,
}) => {
    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} size='lg' backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Detalles de movimiento
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Fecha de despacho:</label>
                    <p>{formatDateAndTime(date)}</p>
                </div>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Tipo de despacho:</label>
                    <p>{issueType}</p>
                </div>
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Solicitante:</label>
                    <p>{requestor}</p>
                </div>
                {vehicle && (
                    <div className='d-flex'>
                        <label className='fw-bold me-3'>Vehículo:</label>
                        <p>{vehicle}</p>
                    </div>
                )}
                {odometer && (
                    <div className='d-flex'>
                        <label className='fw-bold me-3'>Kilometraje:</label>
                        <p>{odometer}</p>
                    </div>
                )}
                <div className='d-flex'>
                    <label className='fw-bold me-3'>Descripción:</label>
                    <p>{description}</p>
                </div>
                {details && (
                    <>
                        <div className='d-flex flex-column'>
                            <table className='table table-bordered my-2'>
                                <thead>
                                    <tr>
                                        <th scope='col'>Artículo</th>
                                        <th scope='col'>Marca</th>
                                        <th scope='col'>Cantidad</th>
                                        <th scope='col'>Precio unitario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {details.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.articleName}</td>
                                            <td>{item.brand}</td>
                                            <td>{item.amount}</td>
                                            <td>{`₡${formatCurrency(item.itemsValue)}`}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex'>
                            <label className='fw-bold me-3'>Total:</label>
                            <p>{`₡${formatCurrency(getTotalItems(details))}`}</p>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <p className='fw-bold me-3'>Desea guardar el movimiento?</p>
                <ModalButton className='cancel' onClick={handleClose}>
                    Cerrar
                </ModalButton>
                <ModalButton className='action' onClick={handleAction}>
                    Guardar
                </ModalButton>
            </Modal.Footer>
        </Modal>
    );
};

export default IssueMovementConfirmationModal;
